var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStressLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.538,
    height: 74.796,
    viewBox: "0 0 57.538 74.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1612",
    transform: "translate(1.414 1.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1609",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2104",
    d: "M746.113,262.6l.714-5.77L743.2,259.3l1.209-6.1",
    transform: "translate(-717.896 -253.2)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2105",
    d: "M725.289,267.13l-2.913-5.056-1.429,4.177L718.2,260.7",
    transform: "translate(-707.393 -256.578)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2276",
    d: "M708.438,280.857l-4.342-3.9-.055,4.4L699.7,276.9",
    transform: "translate(-699.7 -263.875)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2106",
    d: "M765.55,265.793l3.847-4.4H765l4.4-4.4",
    transform: "translate(-726.981 -254.912)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2275",
    d: "M780.8,278.39l5.441-2.088-3.9-2.088,5.935-1.814",
    transform: "translate(-733.399 -261.848)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1610",
    transform: "translate(2.51 15.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1565",
    transform: "translate(19.837 32.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2244",
    d: "M.769,4.891A.751.751,0,0,1,0,4.122H0V.769A.751.751,0,0,1,.769,0a.33.33,0,0,1,.22.055L8.024,2.2a.765.765,0,0,1,.495.934.644.644,0,0,1-.6.495L.879,4.891Zm.714-3.133V3.242l3.078-.55Z",
    fill: "#6a8be5",
    stroke: "#31b2cf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1566",
    transform: "translate(15.101 22.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2245",
    d: "M5.715,5,.11,4.342.275,2.858,2.8,3.133,0,1.264.824,0,6.21,3.627Z",
    fill: "#6a8be5",
    stroke: "#31b2cf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1567",
    transform: "translate(26.496 22.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2246",
    d: "M.495,5,0,3.627,5.386,0,6.21,1.264l-2.8,1.869,2.528-.275L6.1,4.342Z",
    fill: "#6a8be5",
    stroke: "#31b2cf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1579",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1572",
    transform: "translate(0 19.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1568",
    transform: "translate(6.525 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2247",
    d: "M17.193,23.192c-6.59,0-12.221-5.056-13.838-12.42A4.1,4.1,0,0,1,0,6.43C0,4.122,1.438,2.253,3.355,2.088c.18-.714.359-1.374.6-2.088L5.511.495a19.237,19.237,0,0,0-.719,2.473l-.12.769-.839-.165a.233.233,0,0,1-.18-.055c-1.078,0-2.037,1.319-2.037,2.858s.9,2.858,2.037,2.858h.24l.779-.11.12.714c1.318,6.87,6.53,11.871,12.4,11.871s11.083-5,12.4-11.871l.12-.714.9.165h.12c1.078,0,2.037-1.319,2.037-2.858s-.9-2.858-2.037-2.858h-.12l-.839.165-.24-.879A18.439,18.439,0,0,0,29.054.769L30.612.385a10.879,10.879,0,0,1,.359,1.7A4.11,4.11,0,0,1,34.266,6.43c0,2.308-1.438,4.177-3.355,4.342-1.5,7.364-7.129,12.42-13.718,12.42Z",
    transform: "translate(0 0)",
    fill: "#6a8be5",
    stroke: "#31b2cf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1569",
    transform: "translate(0 21.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2248",
    d: "M1.484,16.981H0c0-4.561,4.342-6.54,8.573-8.408C13.08,6.595,17.311,4.671,17.311,0H18.8c0,5.66-5.111,7.969-9.617,9.947-3.957,1.759-7.694,3.462-7.694,7.034Z",
    fill: "#6a8be5",
    stroke: "#31b2cf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1570",
    transform: "translate(28.616 21.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2249",
    d: "M18.8,16.981H17.311c0-3.572-3.737-5.276-7.694-7.034C5.111,7.969,0,5.66,0,0H1.484c0,4.671,4.232,6.595,8.738,8.573C14.453,10.5,18.8,12.42,18.8,16.981Z",
    fill: "#6a8be5",
    stroke: "#31b2cf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2257",
    d: "M25.3,51.2H41.127",
    transform: "translate(-10.027 -23.062)",
    fill: "none",
    stroke: "#31b2cf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1577",
    transform: "translate(1.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2255",
    d: "M.218,21.9A11.2,11.2,0,0,1,3.8,11.131c2.7-2.528,6.229-3.572,10.637-3.3A6.36,6.36,0,0,1,15.321,5.8,10.324,10.324,0,0,1,21.2,1.624a9.226,9.226,0,0,1,4.878.275,5.194,5.194,0,0,0,3.644.055,6.63,6.63,0,0,0,1.7-1.044A2.422,2.422,0,0,1,33.716.14c1.41.385,2.174,2.143,2.292,5.386A11.105,11.105,0,0,1,35.6,9.208H36.83a7.156,7.156,0,0,1,3.35.989,7.446,7.446,0,0,1,3.409,5.715,12.291,12.291,0,0,1-.764,5.221l-1.469-.6A10.535,10.535,0,0,0,42,16.077a6.148,6.148,0,0,0-2.7-4.561,5.867,5.867,0,0,0-2.586-.769,14.414,14.414,0,0,0-2.174.11l-1.352.165.47-1.154a10.53,10.53,0,0,0,.705-4.232c-.118-3.682-1.117-4.012-1.117-4.012-.118,0-.353.11-.764.44a6.89,6.89,0,0,1-2.116,1.264,6.558,6.558,0,0,1-4.7,0,7.27,7.27,0,0,0-4.055-.22A8.307,8.307,0,0,0,16.732,6.57a7.584,7.584,0,0,0-.882,2.253l-.118.714-.764-.165c-4.29-.44-7.581.495-10.049,2.8A9.8,9.8,0,0,0,1.8,21.628Z",
    transform: "translate(0.041 -0.066)",
    fill: "#6a8be5",
    stroke: "#31b2cf",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1578",
    transform: "translate(10.537 12.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2256",
    d: "M4.616,8.7a3.893,3.893,0,0,1-.769-.055A6.592,6.592,0,0,1,0,6.993L.989,5.839A5.061,5.061,0,0,0,4.012,7.158,4.551,4.551,0,0,0,8.024,5.784a4.194,4.194,0,0,0,.769-2.693l-.055-.6.55-.165a3.711,3.711,0,0,1,.769-.11,2.451,2.451,0,0,1,1.814.824,2.819,2.819,0,0,0,2.473.824c.824-.055,1.429-.879,2.033-1.7.934-1.264,2.2-3.023,4.781-1.594l.55.33-.22.6a4.062,4.062,0,0,0,.934,3.957,4.016,4.016,0,0,0,4.342.879l.44,1.429A5.449,5.449,0,0,1,21.323,6.5a5.768,5.768,0,0,1-1.429-4.836c-.989-.33-1.429.22-2.308,1.429-.714.989-1.594,2.2-3.133,2.308a4.253,4.253,0,0,1-3.572-1.154,1.74,1.74,0,0,0-.659-.44,5.164,5.164,0,0,1-1.1,2.968A5.316,5.316,0,0,1,4.616,8.7Z",
    transform: "translate(0 -0.03)",
    fill: "#6a8be5",
    stroke: "#31b2cf",
    strokeWidth: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressLevel);
export default __webpack_public_path__ + "static/media/stress-level.86803e6b84f0880f0bdf2b371b5b4b46.svg";
export { ForwardRef as ReactComponent };